module.exports = __webpack_public_path__ + "static/img/48.a56a5d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/48.png
// module id = zI11
// module chunks = 0